module.exports = __webpack_public_path__ + "static/media/dot_B605D5_a.b0bca371.svg";